import React, { useState, useEffect } from 'react';
import airdrop from "../../assets/images/Airdrop.svg";
import airdropMobile from "../../assets/images/airDropMobile.svg";
import airdropMobileText from "../../assets/images/airDropText.svg";

function AirDrop() {
    const [loading, setLoading] = useState(true);
    const [customContainerDropLoaded, setCustomContainerDropLoaded] = useState(false);

    useEffect(() => {
        const loadImage = (imageSrc: string) => {
            return new Promise<void>((resolve, reject) => {
                const image = new Image();
                image.src = imageSrc;
                image.onload = () => resolve();
                image.onerror = () => reject();
            });
        };

        Promise.all([
            loadImage(airdropMobileText),
            loadImage(airdropMobile)
        ]).then(() => {
            setCustomContainerDropLoaded(true);
        }).catch(() => {
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        if (customContainerDropLoaded) {
            setLoading(false);
        }
    }, [customContainerDropLoaded]);

    return (
        <>
            {loading ? <div className="loader-container">
                <div className="spinner">
                </div>
            </div> : (
                <>
                    <div className='notMobileDevice'>
                        <img alt="drop" className="dropImageDesk" src={airdrop} />
                    </div>
                    <div className='custom-containerDrop'>
                        <img alt="drop" className="mobileDevice dropImageText" src={airdropMobileText} />
                        <img alt="drop" className="mobileDevice dropImage" src={airdropMobile} />
                    </div>
                </>
            )}
        </>
    );
}

export default AirDrop;
